// TODO: user object could be generated from other partial classes. 
// However, this class was implemented at the very begining of the project. So, we are not going to change it now
import { Organisation, DisableReason } from "../models";
export class User {
    salutationCode: string;
    firstName: string;
    middleName: string;
    lastName: string;
    displayName: string;
    dateOfBirth: Date;
    gender: string;
    accountStatusCode: string;
    globalRoleCode: string;
    dioceseId: number;
    diocesePublicId: string;
    extOrganisationId: string;
    email: string;
    mobile: string;
    userId: string;
    password: string;
    confirmPassword: string;
    termsAccepted: boolean;
    secretQuestion1Id: number;
    answer1: string;
    secretQuestion2Id: number;
    answer2: string;
    secretQuestion3Id: number;
    answer3: string;
    disableReasonCode: string;
    disableReasonComment: string;
    organisations: Organisation[];
    recaptchaResponse: string;
    accountId: string;
}


// WEBPACK FOOTER //
// ./src/app/models/user.ts